import { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Play, Pause, Loader2, X, Lock, ShieldCheck, Clock, Headphones,
  Sparkles, CheckCircle2, ChevronDown,
} from "lucide-react";
import { Button } from "../components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import ChatWidgetPink from "../components/ChatWidgetPink";
import { trackVisit, createOrder, trackCtaClick, trackVideo } from "../lib/api";
import { trackClickButton, trackAddToCart, trackInitiateCheckout, trackViewContent } from "../lib/tiktok";
import { pinkPriceLabel } from "../lib/format";
import { useGeo } from "../lib/useGeo";
import { toast } from "sonner";

// Audio (free first session) — uploaded MP4 file.
const PINK_SESSION_1_URL =
  "https://customer-assets.emergentagent.com/job_charisma-protocol/artifacts/4skcixsp_%D8%A7%D9%84%D8%AC%D9%84%D8%B3%D8%A9%20%D8%A7%D9%84%D8%A3%D9%88%D9%84%D9%8A.mp4";
const PINK_LOGO = "/pink/logo.png";

const PINK_THEME = `
  .pink-page { background: #FBF8F6; color: #3E2F32; }
  .pink-page h1, .pink-page h2, .pink-page h3 { color: #3E2F32; }
  .pink-page .accent { color: #8D6E79; }
  .pink-page .gold { color: #C8A977; }
`;

// Sessions
const SESSIONS = [
  { n: 1, title: "لماذا ينسحب الرجل بعد الاهتمام؟", free: true },
  { n: 2, title: "كيف تعرفين أنكِ خيار احتياطي؟" },
  { n: 3, title: "الرجل المتردد ليس لغزاً" },
  { n: 4, title: "لماذا تعلقين بأشخاص لا يعطونكِ ما تريدين؟" },
  { n: 5, title: "كيف يختبر الرجل حدودك؟" },
  { n: 6, title: "الفرق بين الإعجاب الحقيقي والاهتمام المؤقت" },
  { n: 7, title: "كيف تصبحين أصعب على الاستنزاف العاطفي" },
  { n: 8, title: "كيف أبدأ بالحديث مع الرجل؟ بناء الغموض" },
  { n: 9, title: "ماذا أقول؟ ردود ومواقف من العلاقات الحديثة", bonus: true },
];

const BENEFITS = [
  "كيف تفرقين بين الاهتمام الحقيقي والاهتمام المؤقت",
  "لماذا ينسحب الرجل بعد الاهتمام",
  "كيف تعرفين أنكِ خيار احتياطي",
  "كيف تتعاملين مع الرجل المتردد بدون استنزاف",
  "كيف تستعيدين هدوءك وثباتك العاطفي",
];

const PAIN_CARDS = [
  "رجل كان مهتماً جداً... ثم بدأ يبتعد",
  "إشارات مختلطة تستهلك تفكيرك",
  "رسالة واحدة تغيّر مزاجك",
  "تسألين نفسك: هل هو جاد أم فقط يستهلك مشاعري؟",
  "تعبتِ من التحليل، الانتظار، والغموض",
];

const REFRAME_CARDS = [
  { neg: "ليس عن المطاردة", pos: "بل عن الوضوح" },
  { neg: "ليس عن الألعاب", pos: "بل عن الثبات" },
  { neg: "ليس عن إقناعه بقيمتك", pos: "بل عن تذكّرك لها" },
];

const TESTIMONIALS = [
  { quote: "لأول مرة أشعر أن أحداً يشرح ما يحدث فعلاً داخل العلاقات الحديثة.", from: "مستمعة من السعودية" },
  { quote: "الجلسة الخاصة بالرجل المتردد وفرت عليّ شهوراً من التفكير.", from: "مستمعة من الإمارات" },
  { quote: "هذا المحتوى لم يعطني كلاماً جميلاً فقط، بل أعطاني وضوحاً.", from: "مستمعة من الكويت" },
];

const TRUST_CARDS = [
  { title: "خصوصية", body: "لا تحتاجين مشاركة أي بيانات شخصية أو قصة خاصة." },
  { title: "وضوح", body: "المحتوى مباشر، عملي، وبدون تضخيم أو وعود وهمية." },
  { title: "مناسب للخليج", body: "اللغة والنبرة مصممة للمرأة الخليجية الحديثة." },
  { title: "دفع آمن", body: "شراء رقمي ووصول فوري بعد الدفع." },
];

const FAQS = [
  { q: "هل الجلسة الأولى مجانية؟", a: "نعم، يمكنكِ الاستماع إلى الجلسة الأولى مجاناً قبل شراء النسخة الكاملة." },
  { q: "هل هذا المحتوى للنساء فقط؟", a: "نعم، صُمم الكتاب الوردي للنساء فقط، وبنبرة تناسب المرأة الخليجية." },
  { q: "هل هو عن جذب الرجال؟", a: "لا. الكتاب ليس عن المطاردة أو الألعاب النفسية، بل عن فهم العلاقات الحديثة واستعادة الوضوح والثبات." },
  { q: "كيف أصل للجلسات بعد الشراء؟", a: "يصلكِ الوصول فوراً بعد الدفع ويمكنكِ الاستماع من الجوال في أي وقت." },
  { q: "هل السعر شامل كل الجلسات؟", a: "نعم، السعر يشمل 9 جلسات صوتية كاملة." },
];

// ── Session-1 audio modal (locked controls — play/pause only) ──
function SessionOneModal({ open, onClose, onBuy, priceLabel }) {
  const videoRef = useRef(null);
  const fired = useRef(new Set());
  const [playing, setPlaying] = useState(false);
  const [pct, setPct] = useState(0);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      fired.current = new Set();
      setPct(0);
      setPlaying(false);
    } else {
      document.body.style.overflow = "";
      if (videoRef.current) { try { videoRef.current.pause(); } catch (_) {} }
    }
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") return onClose();
      if (["ArrowLeft","ArrowRight","ArrowUp","ArrowDown"," ","j","k","l","f","m"].includes(e.key)) {
        e.preventDefault(); e.stopPropagation();
      }
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, [open, onClose]);

  const playPause = () => {
    const v = videoRef.current; if (!v) return;
    if (v.paused) v.play().catch(() => {}); else v.pause();
  };

  const handleTime = () => {
    const v = videoRef.current;
    if (!v || !v.duration || !isFinite(v.duration)) return;
    const p = (v.currentTime / v.duration) * 100;
    setPct(p);
    [25, 50, 75].forEach((m) => {
      if (p >= m && !fired.current.has(m)) {
        fired.current.add(m);
        trackVideo("progress", m, "pink-session-1");
      }
    });
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center p-3 sm:p-6" data-testid="pink-session-modal" role="dialog">
      <div className="absolute inset-0 bg-[#3E2F32]/85 backdrop-blur-md" onClick={onClose} />
      <div className="relative w-full max-w-2xl max-h-[95vh] overflow-y-auto bg-white border border-[#E8DDD8] rounded-3xl shadow-[0_30px_80px_rgba(62,47,50,0.35)]" dir="rtl">
        <button onClick={onClose} className="absolute top-3 left-3 z-10 text-[#8D6E79] hover:bg-[#F6F1EC] p-2 rounded-full" aria-label="إغلاق" data-testid="pink-session-close">
          <X className="w-5 h-5" />
        </button>

        <div className="px-6 sm:px-9 pt-9 pb-3 text-center">
          <div className="inline-block bg-[#F3E6E8] text-[#8D6E79] text-[10px] sm:text-xs tracking-[0.25em] font-bold px-3 py-1 rounded-full mb-3">
            الجلسة الأولى · مجانية
          </div>
          <h3 className="font-display text-lg sm:text-2xl font-black text-[#3E2F32] leading-snug">
            لماذا ينسحب الرجل بعد الاهتمام؟
          </h3>
        </div>

        <div className="px-3 sm:px-9 py-3">
          <div className="relative w-full bg-[#3E2F32] rounded-2xl overflow-hidden select-none" style={{ aspectRatio: "16 / 9" }} onContextMenu={(e) => e.preventDefault()}>
            <video
              ref={videoRef}
              src={PINK_SESSION_1_URL}
              playsInline
              preload="auto"
              controls={false}
              controlsList="nodownload noremoteplayback noplaybackrate"
              disablePictureInPicture
              disableRemotePlayback
              className="w-full h-full"
              onClick={playPause}
              onPlay={() => {
                setPlaying(true);
                if (!fired.current.has("play")) { fired.current.add("play"); trackVideo("play", 0, "pink-session-1"); }
              }}
              onPause={() => setPlaying(false)}
              onEnded={() => {
                setPlaying(false);
                if (!fired.current.has("complete")) { fired.current.add("complete"); trackVideo("complete", 100, "pink-session-1"); }
              }}
              onTimeUpdate={handleTime}
              data-testid="pink-session-video"
            />
            {!playing && (
              <button type="button" onClick={playPause} aria-label="تشغيل" data-testid="pink-session-play" className="absolute inset-0 flex items-center justify-center bg-[#3E2F32]/30 hover:bg-[#3E2F32]/20 transition-colors">
                <span className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-[#8D6E79] text-white flex items-center justify-center shadow-2xl">
                  <Play className="w-8 h-8 sm:w-10 sm:h-10 mr-1" fill="currentColor" />
                </span>
              </button>
            )}
            <div className="absolute bottom-0 inset-x-0 h-1.5 bg-white/20 pointer-events-none">
              <div className="h-full bg-[#C8A977] transition-[width] duration-150 ease-linear" style={{ width: `${pct}%` }} />
            </div>
          </div>

          <div className="mt-3 flex items-center justify-center gap-3">
            <button type="button" onClick={playPause} data-testid="pink-session-playpause" className="flex items-center gap-2 bg-[#8D6E79] hover:bg-[#7a5d68] text-white px-5 py-2.5 rounded-full text-sm font-bold transition-colors">
              {playing ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
              <span>{playing ? "إيقاف مؤقت" : "تشغيل الجلسة"}</span>
            </button>
          </div>
        </div>

        <div className="px-6 sm:px-9 pb-7 pt-3" dir="rtl">
          <p className="text-center text-sm sm:text-base text-[#5A4A4E] leading-relaxed mb-4">
            انتهيتِ من الجلسة الأولى؟ احصلي على <span className="text-[#8D6E79] font-bold">النسخة الكاملة بكل الجلسات</span> الآن
          </p>
          <Button onClick={onBuy} data-testid="pink-session-modal-buy" className="w-full bg-[#8D6E79] hover:bg-[#7a5d68] text-white font-black text-base sm:text-lg py-6 rounded-full">
            احصلي على النسخة الكاملة · {priceLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}


export default function LandingPink() {
  const navigate = useNavigate();
  const country = useGeo();
  const price = pinkPriceLabel(country);
  const [audioOpen, setAudioOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const trackedOnMount = useRef(false);

  useEffect(() => {
    if (trackedOnMount.current) return;
    trackedOnMount.current = true;
    trackVisit("landing-pink");
    trackViewContent("pink_audio");
  }, []);

  // Set browser tab title to "الكتاب الوردي" while on /pink; restore on unmount.
  useEffect(() => {
    const prev = document.title;
    document.title = "الكتاب الوردي";
    return () => { document.title = prev; };
  }, []);

  const startCheckout = async (source = "cta") => {
    if (loading) return;
    setLoading(true);
    trackClickButton(`pink-${source}`);
    trackCtaClick(`buy-pink-${source}-pink`, "landing-pink");
    trackAddToCart("pink_audio");
    trackInitiateCheckout("pink_audio");
    try {
      const r = await createOrder("pink_audio");
      navigate(`/checkout/${r.order_id}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "تعذّر بدء الدفع، حاولي مرة أخرى.");
    } finally {
      setLoading(false);
    }
  };

  const openSession1 = () => {
    trackCtaClick("pink-session-1-open-pink", "landing-pink");
    trackClickButton("pink-session-1-open");
    setAudioOpen(true);
  };

  return (
    <div className="pink-page min-h-screen" dir="rtl" lang="ar" data-testid="landing-pink-root" style={{ fontFamily: "'IBM Plex Sans Arabic','Tajawal',system-ui,sans-serif" }}>
      <style>{PINK_THEME}</style>

      {/* Top trust strip */}
      <div className="bg-[#3E2F32] text-[#F6F1EC] text-[11px] sm:text-xs py-2 text-center tracking-[0.05em]">
        جلسات صوتية قصيرة · وصول فوري · دفع آمن
      </div>

      {/* Header — desktop AND mobile nav. Anchor links scroll within /pink;
          shared business pages (refund / contact / about) reuse the Gulf
          routes since the company/policy is the same across funnels. */}
      <header className="sticky top-0 z-40 bg-[#FBF8F6]/95 backdrop-blur-sm border-b border-[#E8DDD8]" data-testid="pink-header">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 py-3 flex items-center justify-between gap-3">
          <Link to="/pink" className="flex items-center gap-2.5 shrink-0" data-testid="pink-header-logo">
            <img src={PINK_LOGO} alt="الكتاب الوردي" className="h-10 w-10 sm:h-12 sm:w-12 object-contain" />
            <span className="font-display text-sm sm:text-lg font-bold text-[#3E2F32] hidden xs:inline whitespace-nowrap">الكتاب الوردي</span>
          </Link>
          <nav className="flex items-center gap-3 sm:gap-6 text-[12px] sm:text-sm text-[#5A4A4E] overflow-x-auto whitespace-nowrap" dir="rtl">
            <a href="#about" className="hover:text-[#8D6E79] transition-colors" data-testid="nav-pink-about" onClick={() => trackCtaClick("nav-pink-about", "landing-pink")}>عن الكتاب</a>
            <a href="#sessions" className="hover:text-[#8D6E79] transition-colors" data-testid="nav-pink-sessions" onClick={() => trackCtaClick("nav-pink-sessions", "landing-pink")}>الجلسات</a>
            <a href="#pricing" className="hover:text-[#8D6E79] transition-colors" data-testid="nav-pink-price" onClick={() => trackCtaClick("nav-pink-price", "landing-pink")}>السعر</a>
            <Link to="/refund" className="hover:text-[#8D6E79] transition-colors" data-testid="nav-pink-refund" onClick={() => trackCtaClick("nav-pink-refund", "landing-pink")}>الاسترجاع</Link>
            <Link to="/contact" className="hover:text-[#8D6E79] transition-colors" data-testid="nav-pink-contact" onClick={() => trackCtaClick("nav-pink-contact", "landing-pink")}>تواصل</Link>
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section className="relative overflow-hidden pt-12 pb-16 sm:pt-20 sm:pb-24" style={{ background: "linear-gradient(180deg, #F3E6E8 0%, #FBF8F6 70%)" }}>
        <div className="max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-5 gap-10 items-center">
          <div className="lg:col-span-3 text-right">
            <div className="inline-block bg-white/70 border border-[#E8DDD8] text-[#8D6E79] text-[10px] sm:text-xs tracking-[0.3em] font-bold px-3 py-1.5 rounded-full mb-5">
              للنساء فقط · برنامج صوتي
            </div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.15] tracking-tight text-[#3E2F32]">
              الكتاب الوردي
            </h1>
            <p className="mt-5 text-lg sm:text-2xl text-[#5A4A4E] font-bold leading-snug">
              الأشياء التي لا يقولها أحد عن الرجال والعلاقات الحديثة
            </p>
            <p className="mt-5 text-sm sm:text-base text-[#5A4A4E] leading-relaxed max-w-xl">
              جلسات صوتية قصيرة ومكثفة للمرأة التي سئمت من الحيرة، التعلق، وتحليل الإشارات المختلطة.
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3 max-w-xl">
              <Button data-testid="hero-listen-free-btn" onClick={openSession1} className="flex-1 bg-[#8D6E79] hover:bg-[#7a5d68] text-white font-bold rounded-full py-6 sm:py-7 text-base sm:text-lg shadow-md">
                <Play className="w-4 h-4 ml-2" fill="currentColor" />
                استمعي إلى الجلسة الأولى مجاناً
              </Button>
              <Button data-testid="hero-buy-btn" onClick={() => startCheckout("hero")} disabled={loading} className="flex-1 bg-white hover:bg-[#F6F1EC] text-[#3E2F32] border border-[#E8DDD8] font-bold rounded-full py-6 sm:py-7 text-base sm:text-lg">
                احصلي على النسخة الكاملة
              </Button>
            </div>

            <div className="mt-5 flex items-baseline gap-2.5">
              <span className="font-display text-3xl sm:text-4xl font-black text-[#3E2F32]">{price.number}</span>
              <span className="text-sm sm:text-base text-[#8D6E79] font-bold">{country === "SA" ? "ريال سعودي" : country === "AE" ? "درهم إماراتي" : country === "KW" ? "دينار كويتي" : "USD"}</span>
            </div>

            <div className="mt-5 flex flex-wrap gap-2">
              {["مخصص للنساء فقط", "محتوى صوتي", "وصول فوري", "دفع آمن"].map((b) => (
                <span key={b} className="inline-flex items-center gap-1 bg-white border border-[#E8DDD8] text-[#5A4A4E] text-[11px] sm:text-xs px-3 py-1.5 rounded-full">
                  <CheckCircle2 className="w-3 h-3 text-[#C8A977]" /> {b}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2 flex justify-center">
            {/* Audio-player mock card */}
            <div className="w-full max-w-sm bg-white border border-[#E8DDD8] rounded-3xl p-6 sm:p-7 shadow-[0_30px_60px_rgba(141,110,121,0.18)]" data-testid="hero-audio-card">
              <div className="flex justify-center mb-4">
                <img src={PINK_LOGO} alt="" className="h-28 w-28 sm:h-32 sm:w-32 object-contain" />
              </div>
              <div className="text-center">
                <div className="text-[10px] sm:text-xs tracking-[0.3em] text-[#C8A977] font-bold mb-2">الجلسة الأولى</div>
                <div className="font-display text-base sm:text-lg font-bold text-[#3E2F32] leading-snug mb-4">
                  لماذا ينسحب الرجل بعد الاهتمام؟
                </div>
                <button onClick={openSession1} data-testid="hero-audio-card-btn" className="w-full bg-[#F3E6E8] hover:bg-[#ecd5d9] text-[#8D6E79] font-bold py-3 rounded-full text-sm flex items-center justify-center gap-2 transition-colors">
                  <Play className="w-3.5 h-3.5" fill="currentColor" /> استمعي مجاناً
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pain */}
      <section className="py-14 sm:py-20 bg-[#FBF8F6]">
        <div className="max-w-5xl mx-auto px-5 sm:px-8">
          <h2 className="font-display text-2xl sm:text-4xl font-black text-center text-[#3E2F32] mb-10 sm:mb-14">
            ربما مررتِ بهذا من قبل...
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
            {PAIN_CARDS.map((p, i) => (
              <div key={i} className="bg-white border border-[#E8DDD8] rounded-2xl p-5 sm:p-6 text-[#5A4A4E] text-sm sm:text-base leading-relaxed shadow-sm" data-testid={`pain-${i}`}>
                {p}
              </div>
            ))}
          </div>
          <div className="mt-10 sm:mt-14 bg-gradient-to-br from-[#F3E6E8] to-[#FBF8F6] border border-[#D8B7BE]/50 rounded-3xl p-6 sm:p-10 text-center" data-testid="pain-highlight">
            <p className="font-display text-base sm:text-2xl font-black text-[#3E2F32] leading-relaxed">
              الحقيقة المؤلمة هي أن أغلب النساء لا يعانين من نقص الحب...
              <br className="hidden sm:block"/>
              <span className="text-[#8D6E79]"> بل من كثرة الغموض.</span>
            </p>
          </div>
        </div>
      </section>

      {/* Reframe */}
      <section id="about" className="py-14 sm:py-20 bg-[#F6F1EC]">
        <div className="max-w-5xl mx-auto px-5 sm:px-8">
          <h2 className="font-display text-2xl sm:text-4xl font-black text-center text-[#3E2F32] mb-5">
            هذا ليس كتاباً عن جذب الرجال
          </h2>
          <p className="text-center text-sm sm:text-base text-[#5A4A4E] max-w-3xl mx-auto leading-relaxed mb-10">
            الكتاب الوردي ليس دورة مواعدة، وليس مجموعة حيل نفسية، وليس وعوداً سطحية.
            <br className="hidden sm:block"/>
            هو برنامج صوتي يساعدك على فهم ما يحدث فعلاً داخل العلاقات الحديثة، حتى تتوقفي عن تحليل كل رسالة، وكل اختفاء، وكل إشارة صغيرة.
          </p>
          <div className="grid sm:grid-cols-3 gap-4 sm:gap-5">
            {REFRAME_CARDS.map((c, i) => (
              <div key={i} className="bg-white border border-[#E8DDD8] rounded-2xl p-6 text-center shadow-sm" data-testid={`reframe-${i}`}>
                <div className="text-sm text-[#5A4A4E] line-through mb-2 opacity-70">{c.neg}</div>
                <div className="font-display text-lg sm:text-xl font-black text-[#8D6E79]">{c.pos}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-14 sm:py-20 bg-[#FBF8F6]">
        <div className="max-w-5xl mx-auto px-5 sm:px-8">
          <h2 className="font-display text-2xl sm:text-4xl font-black text-center text-[#3E2F32] mb-10 sm:mb-12">
            ماذا ستتعلمين؟
          </h2>
          <div className="grid sm:grid-cols-2 gap-4">
            {BENEFITS.map((b, i) => (
              <div key={i} className="bg-white border border-[#E8DDD8] rounded-2xl p-5 flex items-start gap-3 shadow-sm" data-testid={`benefit-${i}`}>
                <Sparkles className="w-5 h-5 text-[#C8A977] shrink-0 mt-0.5" />
                <span className="text-sm sm:text-base text-[#3E2F32] leading-relaxed">{b}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sessions */}
      <section id="sessions" className="py-14 sm:py-20 bg-[#F3E6E8]/40">
        <div className="max-w-5xl mx-auto px-5 sm:px-8">
          <h2 className="font-display text-2xl sm:text-4xl font-black text-center text-[#3E2F32] mb-3">
            محتوى الكتاب الصوتي
          </h2>
          <p className="text-center text-sm sm:text-base text-[#5A4A4E] max-w-2xl mx-auto leading-relaxed mb-10">
            9 جلسات صوتية قصيرة، كل جلسة تعالج سؤالاً حقيقياً تعيشه آلاف النساء اليوم.
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {SESSIONS.map((s) => (
              <div key={s.n} className={`relative bg-white border rounded-2xl p-5 shadow-sm ${s.free ? "border-[#C8A977]" : s.bonus ? "border-[#8D6E79]" : "border-[#E8DDD8]"}`} data-testid={`session-${s.n}`}>
                {s.free && (
                  <span className="absolute -top-2 right-4 bg-[#C8A977] text-white text-[10px] font-black px-2.5 py-0.5 rounded-full">مجانية</span>
                )}
                {s.bonus && (
                  <span className="absolute -top-2 right-4 bg-[#8D6E79] text-white text-[10px] font-black px-2.5 py-0.5 rounded-full">Bonus</span>
                )}
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-full bg-[#F6F1EC] text-[#8D6E79] font-display font-black flex items-center justify-center shrink-0 text-sm">
                    {s.n}
                  </div>
                  <div className="font-bold text-[#3E2F32] text-sm sm:text-[15px] leading-snug">
                    {s.title}
                  </div>
                </div>
                {s.free && (
                  <button onClick={openSession1} data-testid={`session-${s.n}-listen`} className="mt-4 w-full bg-[#F3E6E8] hover:bg-[#ecd5d9] text-[#8D6E79] font-bold py-2 rounded-full text-xs flex items-center justify-center gap-2 transition-colors">
                    <Play className="w-3 h-3" fill="currentColor" /> استمعي مجاناً
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About + info cards */}
      <section className="py-14 sm:py-20 bg-[#FBF8F6]">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
          <h2 className="font-display text-2xl sm:text-4xl font-black text-[#3E2F32] mb-5">عن الكتاب</h2>
          <p className="text-sm sm:text-base text-[#5A4A4E] leading-relaxed mb-3">
            الكتاب الوردي برنامج صوتي قصير صُمم للمرأة التي تريد فهماً أعمق للعلاقات الحديثة، بعيداً عن الألعاب، والنصائح السطحية، والوعود الفارغة.
          </p>
          <p className="text-sm sm:text-base text-[#5A4A4E] leading-relaxed mb-10">
            كل جلسة تعالج سؤالاً حقيقياً تعيشه آلاف النساء اليوم، بلغة واضحة، مباشرة، وعملية.
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {[
              { icon: Clock, t: "مدة البرنامج", v: "50–60 دقيقة" },
              { icon: Headphones, t: "الاستماع", v: "من الجوال أي وقت" },
              { icon: Sparkles, t: "الجمهور", v: "نساء الخليج" },
              { icon: Lock, t: "الوصول", v: "فوري بعد الشراء" },
            ].map((c, i) => (
              <div key={i} className="bg-white border border-[#E8DDD8] rounded-2xl p-4 shadow-sm">
                <c.icon className="w-5 h-5 text-[#C8A977] mx-auto mb-2" />
                <div className="text-[11px] tracking-[0.15em] text-[#8D6E79] font-bold">{c.t}</div>
                <div className="text-sm text-[#3E2F32] font-bold mt-1">{c.v}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust */}
      <section className="py-14 sm:py-20 bg-[#F6F1EC]">
        <div className="max-w-5xl mx-auto px-5 sm:px-8">
          <h2 className="font-display text-2xl sm:text-4xl font-black text-center text-[#3E2F32] mb-10">
            لماذا تثقين بهذا المحتوى؟
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {TRUST_CARDS.map((c, i) => (
              <div key={i} className="bg-white border border-[#E8DDD8] rounded-2xl p-5 shadow-sm">
                <ShieldCheck className="w-5 h-5 text-[#C8A977] mb-2" />
                <div className="font-bold text-[#3E2F32] mb-1">{c.title}</div>
                <div className="text-xs sm:text-sm text-[#5A4A4E] leading-relaxed">{c.body}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-14 sm:py-20 bg-[#FBF8F6]">
        <div className="max-w-5xl mx-auto px-5 sm:px-8">
          <h2 className="font-display text-2xl sm:text-4xl font-black text-center text-[#3E2F32] mb-10">
            ماذا قالت المستمعات؟
          </h2>
          <div className="grid sm:grid-cols-3 gap-5">
            {TESTIMONIALS.map((t, i) => (
              <div key={i} className="bg-white border border-[#E8DDD8] rounded-2xl p-6 shadow-sm">
                <div className="text-[#C8A977] text-3xl font-display leading-none mb-3">"</div>
                <p className="text-sm text-[#3E2F32] leading-relaxed mb-4">{t.quote}</p>
                <div className="text-xs text-[#8D6E79] font-bold">{t.from}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section id="pricing" className="py-14 sm:py-20 bg-gradient-to-br from-[#F3E6E8] via-[#FBF8F6] to-[#F6F1EC]">
        <div className="max-w-2xl mx-auto px-5 sm:px-8">
          <h2 className="font-display text-2xl sm:text-4xl font-black text-center text-[#3E2F32] mb-8">
            احصلي على النسخة الكاملة
          </h2>
          <div className="bg-white border-2 border-[#D8B7BE] rounded-3xl p-7 sm:p-10 shadow-[0_30px_60px_rgba(141,110,121,0.2)] text-center" data-testid="pink-pricing-card">
            <div className="flex items-baseline justify-center gap-2 mb-1">
              <span className="font-display text-5xl sm:text-7xl font-black text-[#3E2F32]">{price.number}</span>
              <span className="text-lg sm:text-xl text-[#8D6E79] font-bold">{country === "SA" ? "ريال سعودي" : country === "AE" ? "درهم إماراتي" : country === "KW" ? "دينار كويتي" : "USD"}</span>
            </div>
            <div className="text-xs sm:text-sm text-[#8D6E79] mb-7">دفع مرة واحدة</div>
            <ul className="text-right space-y-2.5 mb-7 text-sm sm:text-base text-[#3E2F32]">
              {["جميع الجلسات الصوتية التسع","وصول فوري","الاستماع من الجوال","جلسة Bonus عملية: ماذا أقول؟"].map((b, i) => (
                <li key={i} className="flex items-center gap-3"><CheckCircle2 className="w-4 h-4 text-[#C8A977] shrink-0" /> {b}</li>
              ))}
            </ul>
            <Button data-testid="pink-pricing-buy-btn" onClick={() => startCheckout("pricing")} disabled={loading} className="w-full bg-[#8D6E79] hover:bg-[#7a5d68] text-white font-black text-base sm:text-lg py-7 rounded-full shadow-md">
              احصلي على النسخة الكاملة الآن
            </Button>
            <button onClick={openSession1} className="mt-4 text-sm text-[#8D6E79] hover:text-[#3E2F32] underline underline-offset-4" data-testid="pricing-listen-free-link">
              أو استمعي إلى الجلسة الأولى مجاناً
            </button>
            <div className="mt-5 text-[11px] text-[#8D6E79]/80">محتوى رقمي يصل فوراً بعد الدفع</div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-14 sm:py-20 bg-[#FBF8F6]">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <h2 className="font-display text-2xl sm:text-4xl font-black text-center text-[#3E2F32] mb-10">
            أسئلة شائعة
          </h2>
          <Accordion type="single" collapsible className="space-y-3" data-testid="pink-faq">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="bg-white border border-[#E8DDD8] rounded-2xl px-5 sm:px-6 data-[state=open]:shadow-sm">
                <AccordionTrigger className="text-right text-sm sm:text-base font-bold text-[#3E2F32] hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="text-sm text-[#5A4A4E] leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-14 sm:py-20 bg-gradient-to-br from-[#3E2F32] to-[#5A4A4E] text-[#FBF8F6]">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <h2 className="font-display text-2xl sm:text-4xl font-black leading-tight">
            إذا تعبتِ من الحيرة... <span className="text-[#D8B7BE]">ابدئي من أول جلسة</span>
          </h2>
          <p className="mt-5 text-sm sm:text-base text-[#FBF8F6]/85 leading-relaxed max-w-2xl mx-auto">
            استمعي إلى الجلسة الأولى مجاناً. وإذا شعرتِ أن هذا المحتوى يتحدث عنكِ، يمكنكِ الحصول على النسخة الكاملة مباشرة.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3 max-w-xl mx-auto">
            <Button onClick={openSession1} data-testid="final-listen-free-btn" className="flex-1 bg-white hover:bg-[#F3E6E8] text-[#3E2F32] font-bold rounded-full py-6 text-base">
              <Play className="w-4 h-4 ml-2" fill="currentColor" />
              استمعي مجاناً
            </Button>
            <Button onClick={() => startCheckout("final")} disabled={loading} data-testid="final-buy-btn" className="flex-1 bg-[#C8A977] hover:bg-[#b8995f] text-[#3E2F32] font-bold rounded-full py-6 text-base">
              احصلي على النسخة الكاملة · {price.primary}
            </Button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#FBF8F6] py-10 border-t border-[#E8DDD8]">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 text-center">
          <div className="flex items-center justify-center gap-3 mb-3">
            <img src={PINK_LOGO} alt="" className="h-9 w-9 object-contain" />
            <span className="font-display font-bold text-[#3E2F32]">الكتاب الوردي</span>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-[#5A4A4E] mb-3">
            <a href="#about" className="hover:text-[#8D6E79]">عن الكتاب</a>
            <a href="#sessions" className="hover:text-[#8D6E79]">الجلسات</a>
            <a href="#pricing" className="hover:text-[#8D6E79]">السعر</a>
            <a href="mailto:support@bluebook.cx" className="hover:text-[#8D6E79]">الدعم</a>
          </div>
          <p className="text-[11px] text-[#8D6E79]/80 max-w-md mx-auto leading-relaxed">
            برنامج صوتي للمرأة التي تريد وضوحاً أكبر في العلاقات الحديثة.
          </p>
        </div>
      </footer>

      {/* Mobile sticky CTA — clear distinction:
              left = free Session 1 (audio preview)
              right = paid full program (9 sessions) */}
      <div className="sm:hidden fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur-md border-t border-[#E8DDD8] px-3 py-2 flex gap-2 shadow-[0_-8px_30px_rgba(62,47,50,0.15)]" data-testid="pink-sticky-cta">
        <Button onClick={openSession1} className="flex-1 bg-white border-2 border-[#E8DDD8] text-[#3E2F32] font-bold rounded-2xl py-4 text-xs leading-tight flex flex-col items-center justify-center gap-0.5">
          <span className="flex items-center gap-1.5">
            <Play className="w-3 h-3" fill="currentColor" />
            <span>الجلسة الأولى</span>
          </span>
          <span className="text-[10px] font-extrabold text-[#8D6E79]">مجاناً · 0 ريال</span>
        </Button>
        <Button onClick={() => startCheckout("sticky")} disabled={loading} className="flex-1 bg-[#8D6E79] hover:bg-[#7a5d68] text-white font-black rounded-2xl py-4 text-xs leading-tight flex flex-col items-center justify-center gap-0.5">
          <span>اشتري البرنامج كاملاً</span>
          <span className="text-[11px] font-extrabold text-[#F3E6E8]">{price.primary}</span>
        </Button>
      </div>

      <SessionOneModal
        open={audioOpen}
        onClose={() => setAudioOpen(false)}
        onBuy={() => { setAudioOpen(false); startCheckout("session-modal"); }}
        priceLabel={price.primary}
      />

      {/* Floating WhatsApp-style chat widget — small, left-anchored to avoid
          overlapping any CTA. All replies come from page-content rules. */}
      <ChatWidgetPink />
    </div>
  );
}
